import React, { Component } from 'react';
import { connect } from 'react-redux';
import weatherIcon from '../../img/weatherIcons.png';
import './style.scss';

class WeatherIcon extends Component {
    constructor(props) {
        super(props);
        this.img = new Image();
        this.img.src = weatherIcon;
        this.imgList = this.props.imgSettings.imgList;
        this.frames = this.props.imgSettings.frames;
        this.width = 0;
        this.height = 0;
        this.ctx = null;
        this.state = {
            imgLoaded: this.props.imgSettings.imgLoaded,
            width: this.props.imgSettings.width ||0,
            height: this.props.imgSettings.height || 0
        }
    }
    setContext = (canvas) => {
        if (!this.ctx) {
            this.ctx = canvas.getContext('2d');
        }
        this.setIcon();
    };
    setIcon = () => {
        if (!this.state.imgLoaded) return;

        this.width = this.state.width / this.frames[0];
        this.height = this.state.height / this.frames[1];
        let xPosition,
            yPosition;

        this.imgList.forEach(item => {
            if (item.name === this.props.imgData.icon) {
                xPosition = this.width * item.position[0];
                yPosition = this.height * item.position[1];
            }
        });
        this.ctx.clearRect(0, 0, this.width, this.height);
        this.ctx.drawImage(this.img, xPosition, yPosition, this.width, this.height, 0, 0, this.width, this.height);

    };
    componentDidUpdate() {
        this.setIcon();
    }
    componentWillReceiveProps(props) {
        let { imgLoaded, width, height } = props.imgSettings
        this.setState({
            imgLoaded,
            width,
            height
        })
    }
    render () {
        return (
            <canvas ref={this.setContext}
                    data-img={this.state.imgLoaded}
                    width={this.state.width / this.frames[0]}
                    height={this.state.height / this.frames[1]}
                    title={this.props.imgData.description}>
            </canvas>
        );
    }
}
export default connect(
    state => ({
        imgSettings: state.weatherIcon
    }),
    dispatch => ({})
)(WeatherIcon);